import React from "react";

import "./SubtleText.scss";

const SubtleText = ({ children }) => {
  return <div className="subtle-text">{children}</div>;
};

export default SubtleText;
